.bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacer-24);
    padding: var(--spacer-24) var(--spacer-40);
    background-color: var(--off-white);
    color: var(--gray-700);
    container-type: inline-size;
}

.group {
    display: flex;
    align-items: stretch;
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.spacer {
    width: 1px;
    height: auto;
    margin-inline: var(--spacer-24);
    background-color: currentcolor;
    flex-shrink: 0;
}

.instantSavings {
    color: var(--red);
}

.totalWithSavings {
    color: var(--black);
}

.savingsInfo {
    width: 16px;
    height: 16px;
    margin-inline: var(--spacer-4) var(--spacer-8);
    vertical-align: top;
}

.savingsInfoSvg {
    fill: currentColor;
}

@container (max-width: 810px) {
    .group:has(.instantSavings) {
        flex-wrap: wrap;
        row-gap: var(--spacer-12);

        > * {
            width: 50%;
            padding-right: var(--spacer-16);
        }

        .spacer {
            display: none;
        }
    }
}
